<div
  [formGroup]="formGroup"
  class="form-group"
  [class.has-error]="!isValid(formGroup, ctrl)"
  [libCtrConfigUI]="ctrl"
  [altura]="ctrl?.Altura"
  [isMobile]="isMobile"
>
  <lib-title-label
    [formGroup]="formGroup"
    [isMobile]="isMobile"
    [enTheme]="enTheme"
    [ctrl]="ctrl"
    #lblTitle
  >
  </lib-title-label>

  <div [ngSwitch]="!showPrescriptionTable && isCompactVersion" class="ctrl">
    <ng-container *ngSwitchCase="true">
      <button mat-icon-button type="button" (click)="onAmpliar_Click($event)">
        <mat-icon>search</mat-icon> <span>Ampliar</span>
      </button>
    </ng-container>

    <ng-container *ngSwitchDefault>
      <ng-container [ngSwitch]="isHtml">
        <ng-container *ngSwitchCase="true">
          <span
            class="form-group"
            [class.has-content]="hasContent"
            [class.black]="enTheme === 'black'"
            [tabIndex]="getTabIndex(ctrl)"
            [libCtrConfigUI]="ctrl"
            [altura]="ctrl?.Altura"
            [isMobile]="isMobile"
            [innerHTML]="ctrl?.ValorTexto"
          ></span>
        </ng-container>

        <ng-container *ngSwitchDefault>
          <!--Carregado se NÃO for Editor Html-->
          <ng-container *ngIf="!showPrescriptionTable">
            <textarea
              [id]="getId(ctrl)"
              pInputTextarea
              class="form-group"
              [class.has-content]="hasContent"
              [class.black]="enTheme === 'black'"
              [tabIndex]="getTabIndex(ctrl)"
              [formControlName]="getId(ctrl)"
              [libCtrConfigUI]="ctrl"
              [altura]="ctrl?.Altura"
              [isMobile]="isMobile"
              [placeholder]="ctrl?.ToolTipMessage || ''"
              style="font-size: 11px"
            ></textarea>
          </ng-container>
          <ng-container
            *ngIf="showPrescriptionTable && prescriptionRows.length === 0"
          >
            <div class="no-prescriptions">
              Nenhuma prescrição ativa encontrada.
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>

  <div *ngIf="showPrescriptionTable && prescriptionRows.length > 0" class="prescription-section">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z1" style="width: 100%;">
      <!-- Nome -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Item</th>
        <td mat-cell *matCellDef="let row">{{ row.name }}</td>
      </ng-container>

      <!-- Dosagem + Unidade -->
      <ng-container matColumnDef="dosage">
        <th mat-header-cell *matHeaderCellDef>Dosagem</th>
        <td mat-cell *matCellDef="let row">{{ row.dosage }}</td>
      </ng-container>

      <!-- Apresentação -->
      <ng-container matColumnDef="presentation">
        <th mat-header-cell *matHeaderCellDef>Apresentação</th>
        <td mat-cell *matCellDef="let row">{{ row.presentation }}</td>
      </ng-container>

      <!-- Posologia -->
      <ng-container matColumnDef="posology">
        <th mat-header-cell *matHeaderCellDef>Posologia</th>
        <td mat-cell *matCellDef="let row">{{ row.posology }}</td>
      </ng-container>

      <!-- Primeira Dose Hora -->
      <ng-container matColumnDef="firstDose">
        <th mat-header-cell *matHeaderCellDef>Primeira Dose</th>
        <td mat-cell *matCellDef="let row">{{ row.firstDose }}</td>
      </ng-container>

      <!-- Horários Personalizados -->
      <ng-container matColumnDef="personalizedTimes">
        <th mat-header-cell *matHeaderCellDef>Horários Personalizados</th>
        <td mat-cell *matCellDef="let row">{{ row.personalizedTimes }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
